import { IBenefit } from "../../../interfaces/api";

const PPODoubleDeepInfoBenefitTripled = ({
  benefit,
  searcher,
  equal,
  differences,
}: {
  benefit: IBenefit[];
  searcher?: string;
  equal?: boolean;
  differences?: boolean;
}) => {
  return (
    <div
      className="grid-x"
      style={{
        width: "100%",
        height: "100%",
        padding: "32px 20px",
        borderBottom: "1px solid #D3E1F0",
        backgroundColor: differences && !equal ? "#F4F0ED" : "transparent",
      }}
    >
      <div
        className="cell small-12"
        style={{ fontSize: "16px", paddingBottom: 18, textAlign: "start" }}
      >
        <div>In-Network</div>
        {benefit[0]?.pbpBenefitDesc
          ? benefit[0].pbpBenefitDesc
              .replace(/In-Network:/g, "")
              .replace(/\\*\\n/g, "\n")
              .replace(/\\/g, "")
              .split("\n")
              .filter(Boolean)
              .map((line, lineIndex) => <div key={lineIndex}>{line}</div>)
          : "-"}
      </div>
      <div
        className="cell small-12"
        style={{ fontSize: "16px", textAlign: "start" }}
      >
        <div>Out-of-Network</div>
        {benefit[0]?.pbpBenefitDesc &&
        !benefit[0].pbpBenefitDesc.includes("In-Network")
          ? benefit[0].pbpBenefitDesc
              .replace(/In-Network:/g, "")
              .replace(/\\*\\n/g, "\n")
              .replace(/\\/g, "")
              .split("\n")
              .filter(Boolean)
              .map((line, lineIndex) => <div key={lineIndex}>{line}</div>)
          : "-"}
      </div>
    </div>
  );
};

export default PPODoubleDeepInfoBenefitTripled;
